import { createSelector } from "@reduxjs/toolkit";

import { IDataKeys, IPermissionType } from "shared/types";
import { dataSelector } from "./helpers";
import { buildData } from ".";
import { IBandUserWithPermissions } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";

export const permissionTypesSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.permissionType) as IPermissionType[]
);

const dataBandUsersPermissionsSelector = createSelector(
  dataSelector,
  data => data.bandUserWithPermissions
);

const dataGroupUsersPermissionsSelector = createSelector(
  dataSelector,
  data => data.groupUserPermissions
);

export const groupPermissionsSelectorCreator = (id: string) =>
  createSelector(dataGroupUsersPermissionsSelector, data => {
    if (!data) return null;

    return buildData(data as any, API_ENDPOINTS.PERMISSION_GROUP(id) as IDataKeys);
  });

export const userPermissionsSelectorCreator = (userId: string) =>
  createSelector(dataBandUsersPermissionsSelector, users => {
    const user = users?.[API_ENDPOINTS.BAND_USER(userId)];
    if (user) {
      return buildSingleItem(user) as IBandUserWithPermissions;
    }
    return null;
  });
